export const preStyles = (role: string) => {
  const standardized = role.toLowerCase();
  if (standardized === "assistant" || standardized === "model") {
    return `bg-gray-100`;
  }
  return `bg-white`;
};
